import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import cronLogo from '../assets/cron-labs-logo.jpeg';

function handleLogout(navigate) {
  try {
    localStorage.clear();
    sessionStorage.clear();
    if ('caches' in window) {
      caches.keys().then(names => Promise.all(names.map(n => caches.delete(n))));
    }
  } catch (e) {}
  navigate('/login', { replace: true });
}

const Sidebar = () => {
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem('role_id') === '1';
  const isManager = localStorage.getItem('role_id') === '3';
  return (
    <aside className="w-56 bg-white min-h-screen shadow-lg px-4 py-8 flex flex-col items-start">
      <div className="flex items-center gap-2 font-bold text-lg mb-10">
        <img src={cronLogo} alt="Cron Labs Logo" className="w-10" />
        <span>Cron Labs</span>
      </div>
      <nav className="flex flex-col gap-3 w-full">
        <NavLink to="/" className={({isActive}) => isActive ? 'bg-indigo-600 text-white rounded-md px-4 py-2' : 'text-slate-800 px-4 py-2 rounded-md hover:bg-indigo-100'}>Home</NavLink>
        <NavLink
          to="/myspace"
          className={({ isActive }) =>
            isActive || window.location.pathname.startsWith('/myspace') 
              ? 'bg-indigo-600 text-white rounded-md px-4 py-2' 
              : 'text-slate-800 px-4 py-2 rounded-md hover:bg-indigo-100'
          }
        >My Space</NavLink>
        {isAdmin && (
          <NavLink
            to="/company"
            className={({ isActive }) =>
              isActive || window.location.pathname.startsWith('/company')
                ? 'bg-indigo-600 text-white rounded-md px-4 py-2' 
                : 'text-slate-800 px-4 py-2 rounded-md hover:bg-indigo-100'
            }
          >
            Company
          </NavLink>
        )}
        {(isAdmin || isManager) && <NavLink
          to="/leavetracker/team"
          className={({ isActive }) =>
            isActive || window.location.pathname.startsWith('/leavetracker/team')
              ? 'bg-indigo-600 text-white rounded-md px-4 py-2' 
              : 'text-slate-800 px-4 py-2 rounded-md hover:bg-indigo-100'
          }
        >Team</NavLink>}
        <NavLink
          to="/leavetracker/mydata"
          className={({ isActive }) =>
            isActive || window.location.pathname.startsWith('/leavetracker/mydata')
              ? 'bg-indigo-600 text-white rounded-md px-4 py-2' 
              : 'text-slate-800 px-4 py-2 rounded-md hover:bg-indigo-100'
          }
        >My Leaves</NavLink>
        <button
          className="text-slate-800 px-4 py-2 rounded-md hover:bg-indigo-100 bg-transparent w-full text-left"
          style={{ outline: 'none', border: 'none', background: 'none', cursor: 'pointer' }}
          onClick={() => handleLogout(navigate)}
        >Logout</button>
      </nav>
    </aside>
  );
};

export default Sidebar;
